module.exports = __webpack_public_path__ + "img/opensans-italic-webfont.1238e642.svg";